import React from "react";
import { Redirect } from "react-router";
import { ROUTE as quizRoute } from "./Quiz";

export const ROUTE = "/bounce";

export function Bounce() {
  return <Redirect to={quizRoute} />;
}
